"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorComponent = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Error_module_css_1 = tslib_1.__importDefault(require("../Errors/Error.module.css"));

var Modal_1 = require("@skbkontur/react-ui/components/Modal");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var Parameters_1 = require("../Control/Parameters");

var Errors_1 = require("../Errors");

var configuration_1 = require("../../contexts/configuration");

exports.ErrorComponent = function (_a) {
  var error = _a.error,
      onAccessConfirmed = _a.onAccessConfirmed;
  return react_1.default.createElement(configuration_1.WithConfiguration, null, function (_a) {
    var _b;

    var customErrors = _a.customErrors,
        helpLinks = _a.helpLinks,
        addToTrustedLink = _a.addToTrustedLink,
        pluginInstallLink = _a.pluginInstallLink,
        installDiskLink = _a.installDiskLink,
        installPluginOnNewTab = _a.installPluginOnNewTab,
        view = _a.view,
        modalOptions = _a.modalOptions,
        trackEvent = _a.trackEvent;
    var errorInfo = {
      title: '',
      message: ''
    }; // Проверяем задана ли кастомная ошибка для текущего error.code.

    if (customErrors && customErrors[error.code]) {
      var customError = customErrors[error.code];

      if (customError instanceof Function) {
        /**
         * Кастомизация задана в виде компонента, возвращаем результат его вызова.
         * В случае отображения списка в модалке, модалка для кастомной ошибки долна
         * рисоваться с функции customError.
         */
        return customError();
      } else {
        // Кастомизация задана структурой.
        errorInfo = tslib_1.__assign({}, customError);
      }
    } else {
      /**
       * Собираем errorInfo из "стандартных" ошибок.
       */
      switch (error.code) {
        case Plugin_1.PluginErrors.PluginCommand:
        case Plugin_1.PluginErrors.PluginTimeoutExpired:
        case Errors_1.DisplayedErrorCodes.NoPlugin:
          {
            errorInfo = Errors_1.NoPlugin({
              pluginInstallLink: pluginInstallLink,
              installPluginOnNewTab: installPluginOnNewTab,
              addToTrustedLink: addToTrustedLink,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.ObsoletePluginVersion:
          {
            errorInfo = Errors_1.NoPlugin({
              pluginInstallLink: pluginInstallLink,
              installPluginOnNewTab: installPluginOnNewTab,
              addToTrustedLink: addToTrustedLink,
              needUpdate: true,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.NotTrustedHost:
          {
            errorInfo = Errors_1.NotTrustedHost({
              addToTrustedLink: addToTrustedLink,
              onAccessConfirmed: onAccessConfirmed,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.NoCryptoPro:
          {
            errorInfo = Errors_1.NoCryptoPro({
              installDiskLink: installDiskLink,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.NoActiveCertificates:
          {
            errorInfo = Errors_1.NoCertificates({
              expiredCertExists: true,
              helpLinks: helpLinks,
              error: error,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.NoValidCertificates:
          {
            errorInfo = Errors_1.NoCertificates({
              expiredCertExists: false,
              helpLinks: helpLinks,
              error: error,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.NoCertificatesByFilter:
          {
            errorInfo = Errors_1.NoCertificatesByFilter({
              helpLinks: helpLinks,
              trackEvent: trackEvent
            });
            break;
          }

        case Errors_1.DisplayedErrorCodes.UnsupportedBrowser:
          {
            errorInfo = Errors_1.UnsupportedBrowser();
            break;
          }

        case Errors_1.DisplayedErrorCodes.UnsupportedOS:
          {
            errorInfo = Errors_1.UnsupportedOS();
            break;
          }

        default:
          {
            var code = error.code || Errors_1.DisplayedErrorCodes.DefaultCertificateListError;
            errorInfo = {
              title: 'Ошибка',
              message: react_1.default.createElement("div", null, "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432\xA0\u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0438\xA0\u0441\u043E\u043E\u0431\u0449\u0438\u0442\u0435 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u0443 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ", code)
            };
          }
      }
    }

    var errorWrapperClassName = classnames_1.default((_b = {}, _b[Error_module_css_1.default.pad] = true, // учитываем легаси параметр view. #legacyView
    _b[Error_module_css_1.default.modal] = view === Parameters_1.CertificatesListView.Modal, _b));

    if (modalOptions) {
      var width = modalOptions.width,
          onClose = modalOptions.onClose,
          ignoreBackgroundClick = modalOptions.ignoreBackgroundClick;
      return react_1.default.createElement(Modal_1.Modal, {
        "data-tid": "modal_error_" + error.code,
        width: width,
        onClose: onClose,
        ignoreBackgroundClick: ignoreBackgroundClick
      }, react_1.default.createElement(Modal_1.Modal.Header, null, errorInfo.title), react_1.default.createElement(Modal_1.Modal.Body, null, errorInfo.message));
    }

    return react_1.default.createElement("div", {
      className: errorWrapperClassName
    }, react_1.default.createElement("div", {
      className: Error_module_css_1.default.caption
    }, errorInfo.title), react_1.default.createElement("div", {
      className: Error_module_css_1.default.text
    }, errorInfo.message));
  });
};